import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Autocomplete,
  CircularProgress
} from '@mui/material';

interface ReportDialogsProps {
  openDialog: boolean;
  openEditDialog: boolean;
  openDeleteDialog: boolean;
  display_name: string;
  embeded_url: string;
  url_type: string;
  description: string;
  maintainer: string;
  contact_info: string;
  allUrlTypes: string[];
  currentIdData: any;
  setDisplayName: (value: string) => void;
  setEmbededURL: (value: string) => void;
  setURLType: (value: string | null) => void;
  setDescription: (value: string) => void;
  setMaintainer: (value: string) => void;
  setContactInfo: (value: string) => void;
  setOpenDialog: (value: boolean) => void;
  setOpenEditDialog: (value: boolean) => void;
  setOpenDeleteDialog: (value: boolean) => void;
  handleSubmit: () => void;
  handleEdit: () => void;
  handleDelete: (data: any) => void;
  handleDialogClose: () => void;
  handleEditDialogClose: () => void;
  loadingAdd: boolean;
}

const ReportDialogs: React.FC<ReportDialogsProps> = ({
  openDialog,
  openEditDialog,
  openDeleteDialog,
  display_name,
  embeded_url,
  url_type,
  description,
  maintainer,
  contact_info,
  allUrlTypes,
  currentIdData,
  setDisplayName,
  setEmbededURL,
  setURLType,
  setDescription,
  setMaintainer,
  setContactInfo,
  setOpenDialog,
  setOpenEditDialog,
  setOpenDeleteDialog,
  handleSubmit,
  handleEdit,
  handleDelete,
  handleDialogClose,
  handleEditDialogClose,
  loadingAdd
}) => {
  return (
    <>
      <Dialog open={openDeleteDialog} onClose={() => setOpenDeleteDialog(false)}>
        <DialogTitle>Are you sure you want to delete?</DialogTitle>
        <DialogActions>
          <Button onClick={() => setOpenDeleteDialog(false)} color="primary">
            Cancel
          </Button>
          <Button
            onClick={() => {
              handleDelete(currentIdData);
            }}
            color="primary"
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={openDialog} onClose={handleDialogClose}>
        <DialogTitle>Add New Report</DialogTitle>
        <DialogContent style={{ padding: "10px" }}>
          <TextField
            label="Display Name"
            value={display_name}
            onChange={(e) => setDisplayName(e.target.value)}
            fullWidth
            style={{ marginBottom: "16px" }}
          />
          <TextField
            label="Embeded URL"
            value={embeded_url}
            onChange={(e) => setEmbededURL(e.target.value)}
            fullWidth
            style={{ marginBottom: "16px" }}
          />
          <Autocomplete
            value={url_type}
            options={allUrlTypes}
            getOptionLabel={(option) => option}
            onChange={(event, value) => setURLType(value)}
            renderInput={(params) => (
              <TextField
                {...params}
                label="URL Type"
                fullWidth
                style={{ marginBottom: "16px" }}
              />
            )}
          />
          <TextField
            label="Description"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            fullWidth
            style={{ marginBottom: "16px" }}
          />
          <TextField
            label="Maintainer"
            value={maintainer}
            onChange={(e) => setMaintainer(e.target.value)}
            fullWidth
            style={{ marginBottom: "16px" }}
          />
          <TextField
            label="Contact Info"
            value={contact_info}
            onChange={(e) => setContactInfo(e.target.value)}
            fullWidth
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDialogClose} color="primary" disabled={loadingAdd}>
            Cancel
          </Button>
          <Button
            onClick={handleSubmit}
            color="primary"
            disabled={loadingAdd}
            startIcon={loadingAdd ? <CircularProgress size={20} /> : null}
          >
            {loadingAdd ? "Saving..." : "Save"}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={openEditDialog} onClose={handleEditDialogClose}>
        <DialogTitle>Edit Item</DialogTitle>
        <DialogContent style={{ padding: "10px" }}>
          <TextField
            label="Display Name"
            value={display_name}
            onChange={(e) => setDisplayName(e.target.value)}
            fullWidth
            style={{ marginBottom: "16px" }}
          />
          <TextField
            label="Embeded URL"
            value={embeded_url}
            onChange={(e) => setEmbededURL(e.target.value)}
            style={{ marginBottom: "16px" }}
            fullWidth
          />
          <Autocomplete
            value={url_type}
            options={allUrlTypes}
            getOptionLabel={(option) => option}
            onChange={(event, value) => setURLType(value)}
            renderInput={(params) => (
              <TextField
                {...params}
                label="URL Type"
                fullWidth
                style={{ marginBottom: "16px" }}
              />
            )}
          />
          <TextField
            label="Description"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            fullWidth
            style={{ marginBottom: "16px" }}
          />
          <TextField
            label="Maintainer"
            value={maintainer}
            onChange={(e) => setMaintainer(e.target.value)}
            fullWidth
            style={{ marginBottom: "16px" }}
          />
          <TextField
            label="Contact Info"
            value={contact_info}
            onChange={(e) => setContactInfo(e.target.value)}
            fullWidth
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleEditDialogClose} color="primary">
            Cancel
          </Button>
          <Button onClick={handleEdit} color="primary">
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ReportDialogs;